import axios from 'axios'

const fetchLanguages = ({ commit, state }) => Object.keys(state.languages).length > 0
  ? Promise.resolve()
  : axios.get('https://skiliko.firebaseio.com/languages.json').then(({ data }) => commit('UPDATE_LANGUAGES', { languages: data }))

const fetchCountries = ({ commit, state }) => Object.keys(state.countries).length > 0
  ? Promise.resolve()
  : axios.get('https://skiliko.firebaseio.com/translations/fr/collection/countries.json').then(({ data }) => commit('UPDATE_COUNTRIES', { countries: data }))

export default {
  fetchLanguages,
  fetchCountries
}



// WEBPACK FOOTER //
// ./src/store/application/actions.js